import Vue from 'vue';
import { DateTime } from 'luxon';

/**
 * Accepts Luxon DateTime and returns the shortname for the given timezone.
 *
 * @param {DateTime|string} value
 * @param {string} timezone
 */
const timezoneShortNameFilter = (value, timezone) => {
    if (!value) {
        return '';
    }

    if (!DateTime.isDateTime(value)) {
        value = DateTime.fromFormat(value, 'yyyy-LL-dd HH:mm:ss', { zone: 'UTC' });
    }

    return value.setZone(timezone).offsetNameShort;
};

Vue.filter('timezoneShortName', timezoneShortNameFilter);

export default timezoneShortNameFilter;
